import {iSolemnlySwearThisHtmlIsClean} from '@frontapp/editor-html';
import {compact, escape} from 'lodash';

import {
  annotationDisableDefaultLinkClickBehavior,
  annotationHtmlAttribute,
  annotationLinkedTypeAttribute,
  htmlAnnotationTagName,
  sourceActivityIdAttribute,
} from '../../../../../../../libs/shared/core/src/helpers/annotations/annotationHelpers';
import {
  AnnotationModel,
  MessageAnnotationModel,
} from '../../../../../../../libs/shared/core/src/models/api/annotationModel';
import {
  AnnotationAnnotatedResourcesEnum,
  AnnotationLinkedResourcesEnum,
} from '../../../../../../../libs/shared/core/src/models/api/annotationTypes';

export function buildAnnotationTagOpen(annotation: MessageAnnotationModel) {
  const annotationLinkedResourceType = annotation.linkedResource.type;
  const shouldDisableDefaultLinkClickBehavior =
    annotation.annotatedResourceType === AnnotationAnnotatedResourcesEnum.MESSAGE;

  // We still add the markjs attribute as there may be some logic relying on this being present
  const attributes = compact([
    `data-markjs="true"`,
    `class="front_annotation"`,
    `${annotationDisableDefaultLinkClickBehavior}="${shouldDisableDefaultLinkClickBehavior}"`,
    `${annotationLinkedTypeAttribute}="${escape(annotationLinkedResourceType)}"`,
    `${annotationHtmlAttribute}="${escape(annotation.clientSideUid)}"`,
    maybeBuildAnnotationDataComment(annotation),
  ]).join(' ');

  return iSolemnlySwearThisHtmlIsClean(`<${htmlAnnotationTagName} ${attributes}>`);
}

function maybeBuildAnnotationDataComment(annotation: AnnotationModel) {
  // Comment drafts can have annotations, but don't have an activity yet.
  if (
    annotation.linkedResource.type !== AnnotationLinkedResourcesEnum.COMMENT ||
    !annotation.linkedResource.commentActivityId
  ) {
    return undefined;
  }
  // This is used to jump to the activity when clicking on the annotation.
  return `${sourceActivityIdAttribute}="${escape(String(annotation.linkedResource.commentActivityId))}"`;
}

const closeTag = iSolemnlySwearThisHtmlIsClean(`</${htmlAnnotationTagName}>`);
export function buildAnnotationCloseTag() {
  return closeTag;
}
